import { TFunction } from 'i18next'

export function createCredentialErrorMessages(t: TFunction) {
  const messages: { [key in DOMException['name']]: string } = {
    InvalidStateError: t('That passkey is already registered.', { context: 'error' }),
  }

  return messages
}
